import React, { useEffect, useRef, useState } from 'react';

import { EntityBadgeById } from '@/lib/crm/components/badges';
import { renderTextWithMentions } from '@/lib/search/parseMentions';

// Typewriter title component - animates when title changes from "New Conversation"
export const TypewriterTitle: React.FC<{ title: string | undefined }> = ({
  title,
}) => {
  const [displayTitle, setDisplayTitle] = useState(title || 'Untitled');
  const prevTitleRef = useRef<string>(title || 'Untitled');

  useEffect(() => {
    const newTitle = title || 'Untitled';
    const prevTitle = prevTitleRef.current;

    // Only animate if title changed from "New Conversation" to something else
    if (prevTitle === 'New Conversation' && newTitle !== 'New Conversation') {
      setDisplayTitle('');
      let i = 0;
      const timer = setInterval(() => {
        if (i < newTitle.length) {
          setDisplayTitle(newTitle.slice(0, i + 1));
          i++;
        } else {
          clearInterval(timer);
        }
      }, 25); // Same timing as sidebar

      prevTitleRef.current = newTitle;
      return () => clearInterval(timer);
    } else {
      setDisplayTitle(newTitle);
      prevTitleRef.current = newTitle;
    }
  }, [title]);

  return displayTitle;
};

// Helper component for rendering message content with @-mentions
export const MessageContent: React.FC<{ text: string; orgId: number }> = ({
  text,
  orgId,
}) => {
  // renderTextWithMentions returns text as React text nodes (safe from XSS)
  // and mentions as EntityBadgeById components
  const content = renderTextWithMentions(text, mention => (
    <EntityBadgeById
      key={`${mention.type}-${mention.entity_id}-${mention.startIndex}`}
      entityId={mention.entity_id}
      orgId={orgId}
      variant='inline'
    />
  ));

  return content;
};
